import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Body, SubmitButton, Field, FormCadastro, GroupField, Input, InputNumber, PageHeader, Select } from '@components';
import { getConexao, putConexao, postConexao, reset } from '@ducks/conectoresConexoes';
import App from '@app';
import { sgdbs } from '../rules';

export default function Cadastro() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [form] = FormCadastro.useForm();
  const { id, idConfiguracao } = useParams();
  const edicao = id !== '-1';

  const conexao = useSelector(({ conectoresConexoes }) => conectoresConexoes.get('conexao'));
  const successConexao = useSelector(({ conectoresConexoes }) => conectoresConexoes.get('successConexao'));

  const successPostConexao = useSelector(({ conectoresConexoes }) => conectoresConexoes.get('successPostConexao'));
  const successPutConexao = useSelector(({ conectoresConexoes }) => conectoresConexoes.get('successPutConexao'));

  const handleReset = () => {
    return dispatch(reset());
  };

  useEffect(() => {
    if (successPostConexao || successPutConexao) {
      handleReset();
      history.goBack();
    }
  }, [successPostConexao, successPutConexao]);

  useEffect(() => {
    form.setFieldsValue({ tp: sgdbs.SQLSERVER });
    if (edicao) {
      dispatch(getConexao(idConfiguracao, id));
    }
  }, []);

  useEffect(() => {
    if (conexao && edicao) {
      form.setFieldsValue(conexao);
    }
  }, [successConexao]);

  const getSGDBS = async () => {
    return sgdbs;
  };

  const handleSubmit = (data) => {
    data.idConfiguracao = idConfiguracao;

    if (edicao) {
      data.id = id;
      dispatch(putConexao(data));
    } else {
      dispatch(postConexao(data));
    }
  };

  return (
    <App>
      <Body>
        <PageHeader title='Conexão' onBack={() => history.goBack()}>
          <FormCadastro form={form} hideRequiredMark onFinish={handleSubmit}>
            <GroupField>
              <Field label='Descrição' name='ds' rules={[{ required: true, message: 'Informe a descrição' }]}>
                <Input autoFocus />
              </Field>
            </GroupField>
            <GroupField>
              <Field label='Host' name='host' rules={[{ required: true, message: 'Informe o host' }]}>
                <Input />
              </Field>
              <Field label='Porta' name='porta' rules={[{ required: true, message: 'Informe a porta' }]}>
                <InputNumber />
              </Field>
              <Field label='Nome do banco' name='banco' rules={[{ required: true, message: 'Informe o nome do banco' }]}>
                <Input />
              </Field>
              <Field label='SGDB' name='tp' rules={[{ required: true, message: 'Informe o SGDB' }]}>
                <Select form={form} allowClear={false} name='metodo' action={() => getSGDBS()} placeholder='Selecione um SGDB' />
              </Field>
            </GroupField>
            <GroupField>
              <Field label='Usuário' name='usuario' rules={[{ required: true, message: 'Informe o usuário' }]}>
                <Input />
              </Field>
              <Field label='Senha' name='senha' rules={[{ required: true, message: 'Informe a senha' }]}>
                <Input.Password />
              </Field>
            </GroupField>
            <GroupField>
              <Field label='Outras Configurações' name='outrasOpcoes'>
                <Input />
              </Field>
            </GroupField>
            <SubmitButton type='success' htmlType='submit' block>
              Salvar
            </SubmitButton>
          </FormCadastro>
        </PageHeader>
      </Body>
    </App>
  );
}
